/**
 * 3.0 콜랩 카드 스타일 — 참가비 · 모금 · 작품 · 체크인.
 * @description 카드 바탕은 DS `Card`(neutral) 가 맡고, 여기서는 안의 줄만 잡는다. 앱 카드와 같은
 *   구성이다 — 제목(+ 상태 배지) → 숫자 → 회색 안내 상자 → 주최자 본인 확인. 앱의 `Details >` 는
 *   웹이 보기 전용이라 없다.
 */
export const collabV3CardStyles = {
  content: "flex w-full flex-col gap-[var(--fw-space-gap-lg)]",
  head: "flex items-center justify-between gap-[var(--fw-space-gap-sm)]",
  title: "fw-h4 text-[var(--fw-color-content-neutral-primary)]",
  amountRow: "flex flex-wrap items-baseline gap-x-[var(--fw-space-gap-xs)]",
  amount: "fw-h3 text-[var(--fw-color-content-neutral-primary)]",
  unit: "fw-b2 text-[var(--fw-color-content-neutral-tertiary)]",
  stack: "flex flex-col gap-[var(--fw-space-gap-sm)]",
  meta: "fw-caption flex items-center justify-between gap-[var(--fw-space-gap-sm)] text-[var(--fw-color-content-neutral-tertiary)]",
  body: "fw-b2 whitespace-pre-line break-words text-[var(--fw-color-content-neutral-secondary)]",
  label: "fw-caption-strong text-[var(--fw-color-content-neutral-tertiary)]",
  info: "fw-b2 whitespace-pre-line break-words rounded-[var(--fw-radius-md)] bg-[var(--fw-color-surface-neutral-secondary)] px-[var(--fw-space-inset-md)] py-[var(--fw-space-inset-sm)] text-[var(--fw-color-content-neutral-secondary)]",
  verified:
    "fw-b2 flex items-center gap-[var(--fw-space-gap-sm)] text-[var(--fw-color-content-neutral-primary)]",
  verifiedIcon:
    "size-[var(--fw-size-icon-sm)] shrink-0 text-[var(--fw-color-content-neutral-secondary)]",
  progress: {
    track:
      "h-[var(--fw-space-gap-sm)] w-full overflow-hidden rounded-[var(--fw-radius-full)] bg-[var(--fw-color-surface-neutral-tertiary)]",
    fill: "block h-full rounded-[var(--fw-radius-full)] transition-[width]",
    brand: "bg-[var(--fw-color-content-brand-primary)]",
    muted: "bg-[var(--fw-color-content-neutral-disabled)]",
  },
  sessions: {
    group: "flex flex-col gap-[var(--fw-space-gap-xs)]",
    date: "fw-caption-strong text-[var(--fw-color-content-neutral-tertiary)]",
    row: "fw-b2 flex items-center justify-between gap-[var(--fw-space-gap-sm)] rounded-[var(--fw-radius-sm)] bg-[var(--fw-color-surface-neutral-secondary)] px-[var(--fw-space-inset-md)] py-[var(--fw-space-inset-sm)]",
    time: "text-[var(--fw-color-content-neutral-primary)]",
    seats: "text-[var(--fw-color-content-neutral-tertiary)]",
    /** 취소 · 마감 · 꽉 참 — 글자만 흐리게(면은 그대로) */
    muted: "[&>span]:text-[var(--fw-color-content-neutral-disabled)]",
  },
  works: {
    chips: "flex flex-wrap gap-[var(--fw-space-gap-xs)]",
    tiles: "grid grid-cols-4 gap-[var(--fw-space-gap-sm)]",
    /** 칸을 덮는 앱 버튼이 칸 안에서만 위에 서도록 쌓임 맥락을 가둔다 */
    tile: "relative isolate aspect-square overflow-hidden rounded-[var(--fw-radius-md)] bg-[var(--fw-color-surface-neutral-secondary)]",
    tileBadge: "absolute left-[var(--fw-space-inset-xs)] top-[var(--fw-space-inset-xs)]",
    footer: "flex flex-wrap items-center justify-between gap-[var(--fw-space-gap-sm)]",
  },
  checkin: {
    head: "flex items-center gap-[var(--fw-space-gap-md)]",
    thumb:
      "relative size-[var(--fw-size-control-xxxxl)] shrink-0 overflow-hidden rounded-[var(--fw-radius-md)] bg-[var(--fw-color-surface-neutral-secondary)]",
    texts: "flex min-w-0 flex-col gap-[var(--fw-space-gap-xxs)]",
  },
};

/** 작품 칸 · 스탬프 그림을 내려받을 폭 */
export const COLLAB_V3_TILE_SIZES = "(min-width: 768px) 200px, 33vw";
export const COLLAB_V3_STAMP_WIDTH = 80;
